module.exports = __webpack_public_path__ + "media/site_templates/www.tradesmennearme.com.au/images/our_services_2-5132daa19ff907265b3f2dbcfab379f5.jpg";